import styled from '@emotion/styled';
import { css } from '@emotion/react';
import CSS from 'csstype';

import { IconName, iconSet } from './constants';

export type IconSize = 6 | 12 | 14 | 16 | 20 | 22 | 24 | 32 | 40;

interface IconProps {
  icon: IconName;
  size: IconSize;
  viewBox?: string;
  color?: string;
  sx?: CSS.Properties;
  onClick?: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
}

const IconBox = styled.i<{ disabled?: boolean }>`
  display: flex;
  position: relative;
  cursor: pointer;

  ${(props) => {
    if (props.disabled) {
      return css`
        opacity: 0.3;
      `;
    }
  }}
`;

export function Icon(props: IconProps) {
  const IconSet = iconSet[props.icon];

  return (
    <IconBox
      style={props.sx}
      disabled={props.disabled}
      onClick={(e) => {
        props.onClick && props.onClick(e);
      }}
    >
      <IconSet
        color={props.color || '#343434'}
        size={props.size}
        viewBox={props.viewBox || '0 0 12 12'}
      />
    </IconBox>
  );
}
